import React from 'react';
import { PopupActionBar, PopupContentWrapper } from '../../../../components';
import {
  SuccesedGoBackButtonLink,
  SuccesedGoToMessagesLink,
  SuccesedText,
  SuccesedTitle,
} from './connected';

export const Succesed = () => (
  <PopupContentWrapper>
    <SuccesedTitle />
    <SuccesedText />

    <PopupActionBar>
      <SuccesedGoToMessagesLink />
      <SuccesedGoBackButtonLink />
    </PopupActionBar>
  </PopupContentWrapper>
);
